import { render, staticRenderFns } from "./iconLightRing.vue?vue&type=template&id=9514b12e&scoped=true"
import script from "./iconLightRing.vue?vue&type=script&lang=js"
export * from "./iconLightRing.vue?vue&type=script&lang=js"
import style0 from "./iconLightRing.vue?vue&type=style&index=0&id=9514b12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9514b12e",
  null
  
)

export default component.exports